module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Энерготрейдинг")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('p', [_vm._v("Согласно действующему законодательству, для отдельных групп крупных промышленных потребителей существует возможность самостоятельного получения статуса субъекта оптового рынка электроэнергии и мощности (ОРЭМ). В этом случае отсутствует необходимость «прослойки» в виде энергосбытовой компании, покупка электроэнергии происходит у оптовых поставщиков – генерирующих компаний, а статус субъекта ОРЭМ получает непосредственно предприятие или группа компаний.")]), _vm._v(" "), _c('p', [_vm._v("Данное обстоятельство гарантирует безопасность финансовых расчетов потребителя с поставщиками и обеспечивает прозрачность цены для собственников крупного бизнеса. ")]), _vm._v(" "), _c('p', [_vm._v("Мы готовы комплексно сопроводить процедуру получения статуса субъекта ОРЭМ с последующим заключением договора энерготрейдинга. Договор включает осуществление процедуры покупки, планирование потребления электроэнергии, предоставление всех необходимых отчетов и аналитики, взаимодействие с финансовыми службами предприятия в рамках составления бюджета и планирования платежей, при этом платежная система «потребитель – поставщик» предполагает прямые расчеты.")])])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d56a638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Trading.vue
// module id = 133
// module chunks = 0